import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import clsx from 'clsx';
import CrehanaForBusiness from '@crehana/icons/logos/CrehanaForBusiness';
import { useOrganizationBranding } from '@crehana/layouts/organization-branding-provider';
import { jsx as _jsx } from "react/jsx-runtime";
var OrganizationLogoImage = function OrganizationLogoImage(_ref) {
  var alt = _ref.alt,
    className = _ref.className;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    is404Image = _useState2[0],
    setIs404Image = _useState2[1];
  var _useOrganizationBrand = useOrganizationBranding(),
    branding = _useOrganizationBrand.branding;
  /**
   * This is a workaround to avoid render a broken image
   */
  var handleImageError = function handleImageError() {
    return setIs404Image(true);
  };
  if (is404Image) {
    return /*#__PURE__*/_jsx(CrehanaForBusiness, {
      size: 32,
      "aria-hidden": true,
      className: className
    });
  }
  return /*#__PURE__*/_jsx("img", {
    src: branding.imageLogo.absoluteUrl,
    alt: alt,
    "aria-hidden": true,
    width: 128,
    className: clsx('tw-max-h-4 tw-w-auto tw-max-w-[12.8rem]', className),
    onError: handleImageError
  });
};
export default OrganizationLogoImage;